import React, { useEffect, useState } from "react";
import Modal from "react-awesome-modal";
import { Link } from "react-router-dom";
import useDelete from "../../Hooks/useDelete";
import useFetch from "../../Hooks/useFetch";
import useSave from "../../Hooks/useSave";
import useUpdate from "../../Hooks/useUpdate";
import useValidateRole from "../../Hooks/useValidateRole";
import Table from "./../../Components/Table";

const ProductHours = (props) => {
    const [open, setOpen] = useState(false);
    const [inputs, setInputs] = useState({});
    const [view, setView] = useState(false);
    const [update, setUpdate] = useState(false);
    const [PageRole, setPageRole] = useState("Product Open Hours");

    const url = "api/productOpenHours";
    const { state, FetchAll } = useFetch(url + "/getAll?page=0&size=10");

    useEffect(() => {
        FetchAll();
    }, []);

    useEffect(() => {
        if (state.data) {
            console.log("Fetched data:", state.data);
        }
    }, [state.data]);

    const handleOpenModal = () => {
        setInputs({});
        setOpen(true);
    };

    const handleInputChange = (event) => {
        event.persist();
        const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;
        setInputs((inputs) => ({ ...inputs, [name]: value }));
    };

    const handleEdit = () => {
        if (inputs.id) {
            setOpen(true);
            setUpdate(true);
            setView(false);
        } else {
            alert("Select a record to edit");
        }
    };

    const handleView = () => {
        if (inputs.id) {
            setView(true);
            setUpdate(false);
            setOpen(true);
        } else {
            alert("Select a record to view");
        }
    };

    const handleSelect = (k) => {
        console.log("Selected item:", k);
        setInputs(k);
    };

    const handleCloseModal = () => {
        setInputs({});
        setOpen(false);
        setView(false);
        setUpdate(false);
    };

    const HandleSave = () => {
        useSave(url, inputs);
        FetchAll();
    };

    const HandleUpdate = () => {
        useUpdate(url + "/" + inputs.id, inputs);
        FetchAll();
    };

    const HandleSubmit = (event) => {
        event.preventDefault();
        if (update) {
            HandleUpdate();
        } else {
            HandleSave();
        }
    };

    const CallDeleteHook = () => {
        useDelete(url + "/" + inputs.id);
        FetchAll();
    };

    const HandleDelete = (event) => {
        event.preventDefault();
        if (inputs.id) {
            CallDeleteHook();
        } else {
            alert("Select a record to delete");
        }
    };

    const formatDate = (timestamp) => {
        if (!timestamp) return "";
        const date = new Date(timestamp);
        return date.toISOString().slice(0, 16);
    };

    const ColumnData = [
        { label: "Product Code", field: "product.code", sort: "asc" },
        { label: "Product Name", field: "product.name", sort: "asc" },
        { label: "Weekday Open", field: "weekDayOpen", sort: "asc" },
        { label: "Weekday Close", field: "weekDayClosingHour", sort: "asc" },
        { label: "Weekend Open", field: "weekendOpeningHour", sort: "asc" },
        { label: "Weekend Close", field: "weekendClosingHours", sort: "asc" },
        { label: "Holiday Open", field: "holidayOpeningHours", sort: "asc" },
        { label: "Holiday Close", field: "holidayClosingHours", sort: "asc" },
    ];

    let RowData = [];
    const rows = state.data?.productOpenHours || [];

    if (rows.length > 0) {
        rows.forEach((k) => {
            const Rowdata = {
                clickEvent: () => handleSelect(k),
                "product.code": k.product.code,
                "product.name": k.product.name,
                weekDayOpen: k.weekDayOpen,
                weekDayClosingHour: k.weekDayClosingHour,
                weekendOpeningHour: k.weekendOpeningHour,
                weekendClosingHours: k.weekendClosingHours,
                holidayOpeningHours: k.holidayOpeningHours,
                holidayClosingHours: k.holidayClosingHours,
            };
            RowData.push(Rowdata);
        });
    }

    const ActionsBtn = () => {
        return (
            <div>
                {useValidateRole(PageRole, "Edit") ? (
                    <button
                        className="btn btn-success p-2"
                        type="button"
                        onClick={handleEdit}
                    >
                        Update
                    </button>
                ) : null}
                &nbsp; &nbsp;
                {useValidateRole(PageRole, "Remove") ? (
                    <button onClick={HandleDelete} className="btn btn-danger p-2">
                        Delete
                    </button>
                ) : null}
                &nbsp;
                <button
                    className="btn btn-warning p-2"
                    type="button"
                    onClick={handleCloseModal}
                >
                    Close
                </button>
            </div>
        );
    };

    return (
        <div id="content" className="content">
            <ol className="breadcrumb float-xl-right">
                <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active">Product Open Hours</li>
            </ol>
            <h1 className="page-header mb-3">Product Open Hours</h1>
            <div style={{ backgroundColor: "white" }}>
                <div className="row">
                    <div className="col-sm-12 d-flex flex-row float-right">
                        &nbsp; &nbsp; &nbsp;
                        {useValidateRole(PageRole, "AddNew") ? (
                            <button
                                onClick={handleOpenModal}
                                className="btn btn-success p-2"
                                style={{ marginRight: 5, marginTop: 5 }}
                            >
                                &nbsp; New &nbsp;
                            </button>
                        ) : null}
                        {useValidateRole(PageRole, "View") ? (
                            <button
                                onClick={handleView}
                                className="btn btn-success p-2"
                                style={{ marginRight: 5, marginTop: 5 }}
                            >
                                &nbsp; View &nbsp;
                            </button>
                        ) : null}
                        {useValidateRole(PageRole, "Edit") ? (
                            <button
                                onClick={handleEdit}
                                className="btn btn-info p-2"
                                style={{ marginRight: 5, marginTop: 5 }}
                            >
                                &nbsp; Edit &nbsp;
                            </button>
                        ) : null}
                        {useValidateRole(PageRole, "Remove") ? (
                            <button
                                onClick={HandleDelete}
                                className="btn btn-danger p-2"
                                style={{ marginRight: 5, marginTop: 5 }}
                            >
                                &nbsp; Delete &nbsp;
                            </button>
                        ) : null}
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <Table Rows={RowData} columns={ColumnData} />
                    </div>
                </div>
            </div>

            <Modal visible={open} width="60%" height="50%" effect="fadeInUp">
                <div style={{ overflowY: "auto", height: "100%" }}>
                    <a className="close" onClick={() => handleCloseModal()}>
                        &times;
                    </a>

                    <div className="row">
                        <div className="col-sm-5"></div>
                        {view ? null : (
                            <div className="col-sm-4 font-weight-bold text-blue">
                                Product Open Hours
                            </div>
                        )}
                    </div>
                    <div className="container-fluid">
                        <div className="col-sm-12">
                            <div className="ibox-content">
                                <br />

                                {view ? (
                                    <div>
                                        <h3>Product Open Hours</h3>
                                        <table className="table table-sm">
                                            <tbody>
                                                <tr>
                                                    <td className="font-weight-bold">Product Code:</td>
                                                    <td>{inputs.product?.code}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Product Name:</td>
                                                    <td>{inputs.product?.name}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Weekday Open:</td>
                                                    <td>{inputs.weekDayOpen}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Weekday Close:</td>
                                                    <td>{inputs.weekDayClosingHour}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Weekend Open:</td>
                                                    <td>{inputs.weekendOpeningHour}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Weekend Close:</td>
                                                    <td>{inputs.weekendClosingHours}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Holiday Open:</td>
                                                    <td>{inputs.holidayOpeningHours}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Holiday Close:</td>
                                                    <td>{inputs.holidayClosingHours}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Created At:</td>
                                                    <td>{inputs.createdAt ? formatDate(inputs.createdAt) : ""}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Created By:</td>
                                                    <td>{inputs.createdBy}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <br />
                                        <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                            <ActionsBtn />
                                        </div>
                                        <br />
                                    </div>
                                ) : (
                                    <form className="form-horizontal" onSubmit={HandleSubmit}>
                                        <div className="row">
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="productId" className="font-weight-bold">
                                                        Product ID
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="productId"
                                                        required
                                                        value={inputs.productId || ""}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="weekDayOpen" className="font-weight-bold">
                                                        Weekday Open
                                                    </label>
                                                    <input
                                                        type="time"
                                                        className="form-control"
                                                        name="weekDayOpen"
                                                        required
                                                        value={inputs.weekDayOpen || ""}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="weekDayClosingHour" className="font-weight-bold">
                                                        Weekday Close
                                                    </label>
                                                    <input
                                                        type="time"
                                                        className="form-control"
                                                        name="weekDayClosingHour"
                                                        required
                                                        value={inputs.weekDayClosingHour || ""}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="weekendOpeningHour" className="font-weight-bold">
                                                        Weekend Open
                                                    </label>
                                                    <input
                                                        type="time"
                                                        className="form-control"
                                                        name="weekendOpeningHour"
                                                        required
                                                        value={inputs.weekendOpeningHour || ""}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="weekendClosingHours" className="font-weight-bold">
                                                        Weekend Close
                                                    </label>
                                                    <input
                                                        type="time"
                                                        className="form-control"
                                                        name="weekendClosingHours"
                                                        required
                                                        value={inputs.weekendClosingHours || ""}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="holidayOpeningHours" className="font-weight-bold">
                                                        Holiday Open
                                                    </label>
                                                    <input
                                                        type="time"
                                                        className="form-control"
                                                        name="holidayOpeningHours"
                                                        required
                                                        value={inputs.holidayOpeningHours || ""}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="holidayClosingHours" className="font-weight-bold">
                                                        Holiday Close
                                                    </label>
                                                    <input
                                                        type="time"
                                                        className="form-control"
                                                        name="holidayClosingHours"
                                                        required
                                                        value={inputs.holidayClosingHours || ""}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="createdAt" className="font-weight-bold">
                                                        Created At
                                                    </label>
                                                    <input
                                                        type="datetime-local"
                                                        className="form-control"
                                                        name="createdAt"
                                                        required
                                                        value={inputs.createdAt ? formatDate(inputs.createdAt) : ""}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="createdBy" className="font-weight-bold">
                                                        Created By
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="createdBy"
                                                        required
                                                        value={inputs.createdBy || ""}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "flex-end",
                                            }}
                                        >
                                            <div className="d-flex flex-row">
                                                {update ? (
                                                    <button className="btn btn-success p-2" type="submit">
                                                        Update
                                                    </button>
                                                ) : (
                                                    <button className="btn btn-success p-2" type="submit">
                                                        Submit
                                                    </button>
                                                )}
                                                &nbsp;
                                                <button
                                                    className="btn btn-warning p-2"
                                                    type="button"
                                                    onClick={handleCloseModal}
                                                >
                                                    Close
                                                </button>
                                            </div>
                                            <br />
                                        </div>
                                    </form>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default ProductHours;
